<template>
  <div class="containerr">
    <section id="banner" class="banner">

      <!-- 最新消息 + 按鈕 -->
      <div class="slogan">
        <h1>最新消息</h1>
        <!-- ===== 文字清單版 ===== -->
        <div class="latest-news">
          <ul class="news-list">
            <li
              v-for="news in newsItems.slice(0, isDesktop ? 7 : 4)"
              :key="news.id"
              class="news-item-text"
              @click="goNewsDetail(news)"
            >
              <span class="news-date">
                {{ formatISODateToCustom(news.updated_at) }}
              </span>
              <span class="news-title">
                <NewsTitle :title="news.title" />
              </span>
            </li>
          </ul>

          <button class="more-btn" @click="navigateToMore">
            更多最新消息
          </button>
        </div>

        <!-- 原本按鈕 -->
        <div class="buttons">
          <button class="btn btn-primary" @click="goMap">
            {{ primaryButtonText }}
          </button>
          <button class="btn btn-secondary" @click="goList">
            {{ secondaryButtonText }}
          </button>
        </div>

        <div class="buttons ticket-row">
          <button class="btn btn-primary" @click="goMonthTicket">
            月票申辦
          </button>

                  <!-- ✅ 新增這顆 -->
        <button class="btn btn-secondary" @click="goQna">
          問題Q&A
        </button>
        </div>
      </div>

      <!-- Banner 左綠右圖 -->
      <div class="banner-content">
        <div class="banner-text"></div>
        <div
          class="banner-image"
          :style="{ backgroundImage: `url(${bannerImg})` }"
        ></div>
      </div>
    </section>
  </div>
</template>

<script>
import {
  onImageError,
  getFullImageURL,
  formatISODateToCustom,
  logNewsClick
} from '@/util/util';

import { globalParams } from '@/global';
import PullDAO from '@/services/PullDAO';
import NewsTitle from '@/components/home/NewsTitle.vue';

const bannerImagePath = process.env.VUE_APP_HOME_BANNER_IMAGE;

export default {
  name: 'AppBanner',

  components: {
    NewsTitle
  },

  data() {
    return {
      primaryButtonText: '找停車場',
      secondaryButtonText: '前往繳費',

      bannerImg: require(`@/assets/${bannerImagePath}`),

      isDesktop: true,

      // ===== 最新消息 =====
      newsItems: [],
      isLoading: false,
      error: null,
      row: 8,
      page: 1

    };
    
  },

  methods: {
    // ===== 原本功能 =====
    goMap() {
      this.$router.push({ name: 'ParkingLots' });
    },
    goList() {
      this.$router.push({ name: 'OnlinePayment' });
    },
    goMonthTicket() {
      this.$router.push('/UserApply');
    },
    goQna() {
      window.location.href = 'https://www.taiwan-parking.com.tw/#/qna';
    },
    // ===== util =====
    formatISODateToCustom,
    onImageError,
    getFullImageURL,

    // ===== API =====
    async fetchNews() {
      this.isLoading = true;
      this.error = null;

      const pullDAO = new PullDAO();

      try {
        const newsData = await pullDAO.listNews(this.row, this.page);

        // ⚠️ 依 API 回傳格式調整
        this.newsItems = newsData.news || [];
      } catch (error) {
        console.error(error);
        this.error = error.message || '無法加載最新消息';
      } finally {
        this.isLoading = false;
      }
    },

    goNewsDetail(news) {
      logNewsClick(news, 'banner');
      globalParams.shownNews = news;
      this.$router.push('/news-detail');
    },

    navigateToMore() {
      this.$router.push('/all-news');
    }
  },

  mounted() {
    this.isDesktop = window.innerWidth > 768;  // >768 視為桌機
    this.fetchNews();
  }
};
</script>

<style scoped>
.containerr {
  width: 100%;
}

.ticket-row {
  margin-top: 12px;
}

.banner {
  position: relative;
  margin-top: -2px;
  width: 100%;
  height: 980px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  overflow: hidden;
}

.slogan {
  position: absolute;
  top: 168px;
  left: 0;
  width: 760px;
  color: white;
  padding: 0 7%;
  text-align: left;
  z-index: 2;
}

.slogan h1 {
  font-size: 80px;
  font-weight: 700;
  margin-bottom: 2px;
}

/* ===== 最新消息（文字版） ===== */
.latest-news {
  margin-top: 2px;
}

.news-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.news-item-text {
  display: flex;
  gap: 12px;
  padding: 10px 0;
  cursor: pointer;
  border-bottom: 1px solid rgba(255,255,255,0.2);
  transition: all 0.2s ease;
}

.news-item-text:hover {
  opacity: 0.8;
  transform: translateX(6px);
}

.news-date {
  font-size: 14px;
  opacity: 0.8;
  min-width: 95px;
}

.news-title {
  font-size: 16px;
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* 綠底上紅字看不清楚：警示字樣改白底紅字標籤（❗ 本身是紅色，不能放紅底） */
.news-title :deep(.news-alert) {
  background-color: white;
  padding: 0 8px;
  border-radius: 4px;
  margin-right: 4px;
}

.more-btn {
  margin-top: 12px;
  padding: 8px 16px;
  border-radius: 20px;
  border: none;
  cursor: pointer;
}

/* ===== 按鈕 ===== */
.buttons {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  margin-top: 1rem;
}

.btn {
  padding: 16px 40px;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-size: 20px;
  font-weight: 700;
  min-width: 120px;
}

.btn-primary {
  background-color: white;
  color: var(--green03);
}

.btn-secondary {
  background-color: transparent;
  border: 2px solid white;
  color: white;
}

/* ===== Banner 結構 ===== */
.banner-content {
  display: flex;
  width: 100%;
  height: 100%;
}

.banner-text {
  flex: 1;
  background-color: var(--green03);
}

.banner-image {
  flex: 1;
  background-size: cover;
  background-position: center;
}

/* ===== RWD ===== */
@media (max-width: 800px) {
  .slogan {
    top: 200px;
    width: 520px;
  }

  .slogan h1 {
    font-size: 3.5rem;
  }
}

@media (max-width: 560px) {
  .banner {
    height: 640px;
  }

  /* 長標題不再單行省略：日期獨立一行，標題可換行最多兩行 */
  .news-item-text {
    flex-direction: column;
    gap: 2px;
    padding: 8px 0;
  }

  .news-date {
    min-width: 0;
    font-size: 13px;
  }

  .news-title {
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.4;
  }

  .slogan {
    top: 68px;
    width: 90%;
  }

  .slogan h1 {
    font-size: 2rem;
    margin-bottom: 1px;
  }

  .btn {
    font-size: 14px;
    padding: 15px 35px;
  }

  .banner-image::after {
    background: rgba(0, 0, 0, 0.45);  /* 手機可以再深一點 */
  }
}

@media (max-width: 360px) {
  .banner {
    height: 620px;
  }

  .slogan h1 {
    font-size: 2.5rem;
  }
}
</style>